import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';
import {
  clearFinanceViewAsSession,
  FINANCE_VIEW_AS_SESSION_KEY
} from '../utils/financeViewAsClient';
import Loading from './Loading';

const isFinanceStatementRoute = (pathname) => pathname === '/organiser/finance';

function FinanceViewAsRouteGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [, setReleaseVersion] = useState(0);
  const sessionId = sessionStorage.getItem(FINANCE_VIEW_AS_SESSION_KEY) || '';
  const mustEndSession = Boolean(sessionId) && !isFinanceStatementRoute(location.pathname);

  useEffect(() => {
    if (!mustEndSession) return undefined;

    let active = true;
    const endBeforeLeaving = async () => {
      try {
        await api.delete(`/admin/finance/era2/view-as-sessions/${sessionId}`, {
          withCredentials: true,
          financeViewAs: true
        });
        clearFinanceViewAsSession();
        if (active) setReleaseVersion((value) => value + 1);
      } catch (error) {
        if ([401, 404].includes(error.response?.status)) {
          clearFinanceViewAsSession();
          if (active) setReleaseVersion((value) => value + 1);
          return;
        }
        if (active) {
          toast.error('The read-only view could not be ended safely. You have been returned to it.');
          navigate('/organiser/finance?viewAs=1', { replace: true });
        }
      }
    };

    void endBeforeLeaving();
    return () => {
      active = false;
    };
  }, [mustEndSession, navigate, sessionId]);

  if (mustEndSession) {
    return <Loading page text="Ending read-only organiser view..." />;
  }

  return children;
}

export default FinanceViewAsRouteGuard;
